// @flow

import Path from 'routes/path'
import { type ReservationType } from 'types/v1/reservation'
import { type PropTypes as BillStatementProps, type BillItem } from './index'

function getBillItem(
  reservedValue: number,
  reservedText: string,
  name?: string,
): Array<BillItem> {
  if (reservedValue && reservedValue !== 0) {
    return {
      name,
      price: reservedText,
    }
  }
  return undefined
}

export function getBillStatementCurrentProps(reservation: ReservationType) {
  const reservedPlan = reservation.plan || {}
  const reservedBilling = reservation.billing || {}

  // お支払い情報がない場合
  if (!reservedBilling.id) {
    return null
  }

  return {
    hrefReceipt: reservation.can_show_receipt
      ? Path.reservationReceipt(reservation.id)
      : undefined,
    planBillItem: {
      name: reservedPlan.name,
      price: reservedBilling.room_amount_text,
    },
    extraGuestStayBillItem: getBillItem(
      reservedBilling.extra_guest_stay_amount,
      reservedBilling.extra_guest_stay_amount_text,
    ),
    optionCleaningBillItem: getBillItem(
      reservedBilling.option_cleaning_amount,
      reservedBilling.option_cleaning_amount_text,
    ),
    optionBillItemList: (reservation.reserved_option_items || []).map(
      option => ({
        name: option.name,
        price: option.total_amount_text,
        number: option.countable && option.number,
      }),
    ),
    changePriceBillItem: getBillItem(
      parseInt(reservedBilling.change_amount, 10),
      reservedBilling.change_amount_text,
      reservedBilling.change_description,
    ),
    lastMinuteDiscountBillItem: getBillItem(
      reservedBilling.last_minute_discount_amount_except_tax,
      `-${reservedBilling.last_minute_discount_amount_except_tax_text}`,
    ),
    weeklyDiscountBillItem: getBillItem(
      reservedBilling.weekly_discount_amount,
      `-${reservedBilling.weekly_discount_amount_text}`,
    ),
    monthlyDiscountBillItem: getBillItem(
      reservedBilling.monthly_discount_amount,
      `-${reservedBilling.monthly_discount_amount_text}`,
    ),
    guestFeeBillItem: getBillItem(
      reservedBilling.guest_fee_amount,
      reservedBilling.guest_fee_amount_text,
    ),
    pointDiscountBillItem: getBillItem(
      reservedBilling.point_discount_amount,
      `-${reservedBilling.point_discount_amount_text}`,
    ),
    guestPostpayFeeBillItem: getBillItem(
      reservedBilling.guest_postpay_fee_amount,
      reservedBilling.guest_postpay_fee_amount_text,
    ),
    salesTaxBillItem: getBillItem(
      reservedBilling.guest_sales_tax,
      reservedBilling.guest_sales_tax_text,
    ),
    couponDiscountBillItem: getBillItem(
      reservedBilling.discount_amount,
      reservedBilling.discount_amount_text,
    ),
    billTotal: reservedBilling.total_pay_amount_for_user_with_tax_text,
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/BillStatementCurrent/presenter.js